import { render, staticRenderFns } from "./AccessQuickButton.vue?vue&type=template&id=c730b51a&scoped=true&"
import script from "./AccessQuickButton.vue?vue&type=script&lang=js&"
export * from "./AccessQuickButton.vue?vue&type=script&lang=js&"
import style0 from "./AccessQuickButton.vue?vue&type=style&index=0&id=c730b51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c730b51a",
  null
  
)

export default component.exports